const addOpponentCard = (card) => {
  return { type: "ADD_OPPONENT_CARD", payload: card };
};

export default addOpponentCard;
